import { Select } from "antd";
import React from "react";

export default function Recipients({ value, setValue }) {
   //updates state
   const handleChange = (value, option) => {
      setValue(option.value);
   };

   const options = [
      { value: "Client", key: 1 },
      { value: "Stock", key: 2 },
      { value: "Production", key: 3 },
   ];

   //select style
   const style = { width: "100%" };
   return (
      <>
         <Select onChange={handleChange} value={value && value} style={style} placeholder="Select recipient" optionFilterProp="children" options={options} />
      </>
   );
}
